import { usersListItems as usersListItemsSelector } from '@cd3p/core/selectors/usersList';
import {
  hideUserSensitiveFields,
  userHasSensitiveData,
} from '@cd3p/core/utils/sensitiveData';
import { userType as userTypeSelector } from 'selectors/app';

import { createSelector } from 'third-party';

export {
  loadMoreUsersListPending,
  loadUsersListPending,
  usersListCount,
  usersListItems,
  usersListLoaded,
  usersListPagination,
  usersListSorting,
  deleteUserPending,
  resendUserInvitePending,
} from '@cd3p/core/selectors/usersList';

export const usersList = createSelector(
  [usersListItemsSelector, userTypeSelector],
  (users, userType) => {
    return users.map(user =>
      userHasSensitiveData(user, userType)
        ? hideUserSensitiveFields(user)
        : user,
    );
  },
);
